import React, { lazy } from 'react';

const AccessoriesComponent = lazy(
  () => import(/* webpackChunkName: "carvana-purchase-accessories" */ './accessories')
);

export const AccessoriesRoute = () => {
  return <AccessoriesComponent />;
};
